export enum RoundMode {
  UP = 'up',
  DOWN = 'down',
  NONE = 'none',
}
